// import React, { useEffect, useState } from "react";
// import "./style.css";

// const CustomToast = ({ onClose }) => {
//   const correct = `${process.env.PUBLIC_URL}/custom-icons/correct.png`;
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       onClose();
//     }, 6000); // 6 seconds

//     return () => clearTimeout(timer);
//   }, [onClose]);

//   return (
//     <div className="toast">
//       <div className="toast-message">
//         <img src={correct} style={{width:"25px",height:"25px",marginTop:"1rem",marginBottom:"0.4rem"}}/>
//         <p style={{fontSize:"1.1rem",fontWeight:"500",marginBottom:"0.3rem"}}>Video is correct</p>
//         <p style={{fontSize:"1rem"}}>Proceeding to next step in 6s</p>
//         </div>
//       <div className="toast-line"></div>
//     </div>
//   );
// };

// const CustomVideoToastify = () => {
//   const [showToast, setShowToast] = useState(false);

//   const handleShowToast = () => {
//     setShowToast(true);
//   };

//   const handleCloseToast = () => {
//     setShowToast(false);
//   };

//   return (
//     <div>
//       {/* <button onClick={handleShowToast}>Show Toast</button> */}
//      <CustomToast  onClose={handleCloseToast} />
//     </div>
//   );
// };

// export default CustomVideoToastify;
import React, { useEffect, useState } from "react";
import "./style.css";

const CustomToast = ({ onClose }) => {
  const correct = `${process.env.PUBLIC_URL}/custom-icons/correct.png`;
  const [countdown, setCountdown] = useState(6);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) {
          clearInterval(timer);
          onClose(); // Close when countdown reaches 0
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [onClose]);

  return (
    <div className="toast">
      <div className="toast-message">
        <img
          src={correct}
          style={{ width: "25px", height: "25px", marginTop: "1rem", marginBottom: "0.4rem" }}
          alt="Success"
        />
        <p style={{ fontSize: "1.1rem", fontWeight: "500", marginBottom: "0.3rem" }}>
          Video is correct ?
        </p>
        <p style={{ fontSize: "1rem" }}>Proceeding to next step in </p>
        <p>{countdown}s</p>
      </div>
      <div className="toast-line"></div>
    </div>
  );
};

const CustomVideoToastify = () => {
  const [showToast, setShowToast] = useState(true);

  const handleCloseToast = () => {
    setShowToast(false);
  };

  return <div>{showToast && <CustomToast onClose={handleCloseToast} />}</div>;
};

export default CustomVideoToastify;
